import React from 'react';

const About: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8">About Eventory</h1>
      <div className="prose prose-lg">
        <p>
          Eventory is your one-stop platform for discovering, creating, and managing events.
          Whether you're an event organizer or an attendee, we make it easy to connect
          with the experiences that matter to you.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4">Our Mission</h2>
        <p>
          Our mission is to bring people together through meaningful events and experiences.
          We believe that every event has the potential to create lasting memories and
          connections.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4">What We Offer</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Easy event creation and management</li>
          <li>Seamless ticket booking experience</li>
          <li>Powerful organizer tools and analytics</li>
          <li>Secure payment processing</li>
          <li>Real-time updates and notifications</li>
        </ul>
      </div>
    </div>
  );
};

export default About; 